import { Button, Text, Tooltip } from "@fluentui/react-components";
import { CopyFilled, PersonCircleFilled } from "@fluentui/react-icons";
import { Col, Container, Row } from "react-grid-system";
import IPassword from "../../../../models/password/IPassword";
import { useTranslation } from "react-i18next";
import Password from "./Password";
import useStyleUtils from "../../../../utilities/styles";
import styles from './PasswordDetail.module.scss';

export default function Details(props: { password: IPassword }) {
    const { t } = useTranslation();

    const style = useStyleUtils();

    const handleCopyUsernameClicked = () => navigator.clipboard.writeText(props.password.username);
    
    return (
        <Container fluid className={style.px0i}>
            <Row align="center" className={style.mb2}>
                <Col xs="content" className={style.textCenter}>
                    <PersonCircleFilled />
                </Col>
                <Col>
                    <Text size={400} className={styles.detail}>
                        {props.password.username}
                    </Text>
                </Col>
                <Col xs="content" className={style.textRight}>
                    <Tooltip content={t("general.copyToClipboard")} relationship='label'>
                        <Button size="small" icon={<CopyFilled />} onClick={handleCopyUsernameClicked} />
                    </Tooltip>
                </Col>
            </Row>
            <Password {...props} />
            {
                props.password.notes &&
                <Row>
                    <Col xs={12}>
                        <div>
                            <strong>{t("passwords.notes")}</strong>
                        </div>
                        <div style={{ whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{ __html: props.password.notes || "" }} />
                    </Col>
                </Row>
            }
        </Container>
    );
}